import React, { useEffect } from "react";
import { Pagination  } from 'antd';
import { connect } from "react-redux";
import { 
    getTrainingModuleResultList,
} from "../../../../../redux/trainingclass/trainingClassState";
import Card from "components/card";
import SearchFilter from "components/search/SearchFilter";
import { BookOpen } from "lucide-react";
import TrainingModuleCard from "views/console/training-modules/components/TrainingModuleCard";

const TrainingModuleResultTable = ({ 
    recordList, 
    pagination, 
    doSearch, 
    filters, 
    classeId 
}) => {
    
    useEffect(() => {
        if (classeId) {
            doSearch({paginate: pagination.per_page, classeId});
        } 
    }, [doSearch, classeId, pagination.per_page]);

    return (  

        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-slate-200 dark-mode-card">
			<div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
				<div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
					<div>
						<h4 className="text-[16px] leading-none title-text">
							Module Results
						</h4>
                        <p className="text-[13px] muted-text">
							Manage and review participant scores.
						</p>
					</div>
					<div className="flex-1 min-w-0 sm:w-[600px]">
						<SearchFilter placeholder="Search by module or pariticipant name..." searchHandler={doSearch} filters={filters} pagination={pagination}/>
					</div>
				</div>
			</div>
			<div className="px-6 pb-6">
				<div className="space-y-4">
					{recordList && recordList.length > 0 ? (
						recordList.map((module_result) => 
							<TrainingModuleCard 
								key={module_result.trs_id}
								recordData={module_result}
                                showStat={false}
                                showResult={true}
							/>)
						) : (
						<div className="text-center py-12 muted-text">
							<BookOpen className="w-12 h-12 mx-auto mb-4"/>
							<p className="">No modules found matching the filters</p>
						</div>
					)}
				</div>
				<div className="flex justify-end py-4">
					<Pagination
						current={pagination.current_page}
						pageSize={pagination.per_page}
						total={pagination.total}
						showSizeChanger={false}
						onChange={(page) =>
                            doSearch({
                                ...filters,
                                page,
                                paginate: pagination.per_page,
                            })
						}
					/>
				</div>
			</div>
		</Card>
    );
};

const mapStateToProps = (state) => ({
  recordList: state.trainingClass.trainingModuleResultList?.items,
  pagination: state.trainingClass.trainingModuleResultList?.pagination,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getTrainingModuleResultList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleResultTable);
